import { pixels } from "../../constants/pixels";

export const windowHeaderSum = (walls, e, k) => {
  const arr = [];
  walls.forEach((e) => {
    if (e.windows) {
      arr.push(e);
    }
  });
  if (arr.length) {
    return (
      [...arr]
        .sort(
          (a, b) =>
            arr.filter((v) => v[e][k] === a[e][k]).length -
            arr.filter((v) => v[e][k] === b[e][k])
        )
        .pop()[e][k] / pixels
    );
  }
  return null;
};

export const doorHeaderSum = (walls, k) => {
  const arr = [];
  walls.forEach((e) => {
    if (e.doors) {
      arr.push(e);
    }
  });
  if (arr.length) {
    return (
      [...arr]
        .sort(
          (a, b) =>
            arr.filter((v) => v[k] === a[k]).length -
            arr.filter((v) => v[k] === b[k])
        )
        .pop()[k] / pixels
    );
  }
  return null;
};
